import { useState } from 'react';
import { Link } from 'react-router-dom';

// Recovery path per plan/05 §What if the SW itself is broken: visiting
// /admin/reset-sw lets a parent unregister every Service Worker on the
// origin and clear the Cache Storage, so a borked install can recover
// without needing devtools.
//
// Not linked from the UI on purpose — typed in by hand when needed. PIN
// gate doesn't apply: the whole point is to recover a device that may not
// be able to load the app at all.
export function AdminResetSwPage() {
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onReset = async () => {
    setBusy(true);
    setError(null);
    try {
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
      if (typeof caches !== 'undefined') {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
      setDone(true);
    } catch (e) {
      console.error('SW reset failed', e);
      setError(e instanceof Error ? e.message : 'Tuntematon virhe.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="settings">
      <h1 className="settings-title">Palauta sovellus</h1>
      <section className="settings-section">
        <p className="settings-hint">
          Tämä poistaa Service Workerin rekisteröinnit ja tyhjentää välimuistin. Käytä, jos sovellus
          juuttuu vanhaan versioon. Profiilit ja rutiinit pysyvät tallessa.
        </p>
        <button
          type="button"
          className="settings-button settings-button-danger"
          onClick={onReset}
          disabled={busy || done}
        >
          {done ? 'Valmis' : busy ? 'Tyhjennetään…' : 'Tyhjennä välimuisti'}
        </button>
        {done && (
          <p className="settings-hint" role="status">
            Valmis. Lataa sivu uudelleen ottaaksesi uuden version käyttöön.
          </p>
        )}
        {error && (
          <p className="settings-error" role="alert">
            {error}
          </p>
        )}
      </section>
      <section className="settings-section">
        <Link to="/" className="settings-button">
          Takaisin etusivulle
        </Link>
      </section>
    </main>
  );
}
